import {mapState} from "ui.vue3.vuex";

export const Modal = {
    data(): object {
        return {
            errorComment: "",
            isSend: false,
        }
    },
    computed: {
        ...mapState('itemsStore', ['detailItem']),
    },
    methods: {
        getClassItem(id) {
            let classColor = '';
            switch (id) {
                case 'Кванториумы':
                    // Кванториумы
                    classColor = 'pink';
                    break;
                case 'IT-кубы':
                    // IT-кубы
                    classColor = 'green';
                    break;
                case 'Точки роста и школьные лаборатории':
                    // Точки роста и школьные лаборатории
                    classColor = 'turquoise';
                    break;
                case 'Психолого-педагогические классы':
                    // Психолого-педагогические классы
                    classColor = 'purple';
                    break;
                case 'Воспитательные практики':
                    // Воспитательные практики
                    classColor = 'mark';
                    break;
                case 'Диалог с родителями':
                    // Диалог с родителями
                    classColor = 'green-lt';
                    break;
                case 'Образовательный контент по предметам':
                    // Образовательный контент по предметам
                    classColor = 'mint';
                    break;
                case 'Дополнительное образование детей':
                    // Дополнительное образование детей
                    classColor = 'green';
                    break;
                case 'Справочник научно-методических разработок':
                    // Справочник научно-методических разработок
                    classColor = 'turquoise';
                    break;
            }

            return classColor;
        },
        getAuthorInfo(info) {
            let tmp = [];
            if(info.title !== null) {
                tmp.push(info.title);
            }
            if(info.degree !== null) {
                tmp.push(info.degree);
            }
            let $return = tmp.join(', ');
            if($return !== '') {
                return ' (' + $return + ')';
            } else {
                return '';
            }
        },
        async sendForm(id) {
            let token = document.forms.error.elements['smart-token'].value;

            if(this.errorComment !== '' && token !== '') {
                let message = {
                    message: this.errorComment,
                    token: token
                };

                let response = await fetch(`https://navigator.apkpro.ru/api/publications/${id}/error`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(message)
                });

                let result = parseInt(await response.text());

                if (result == 1) {
                    this.isSend = true;
                } else {
                    console.log(response);
                }
            }
        },
        changeFormatDate(date) {
            let dateString = new Date(date);

            const yyyy = dateString.getFullYear();
            let mm = dateString.getMonth() + 1; // Months start at 0!
            let dd = dateString.getDate();

            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;

            return dd + '.' + mm + '.' + yyyy;
        }
    },
    template: `
    <div class="hidden">
        <div class="popup methodological-popup" id="popup-methodological-item">
            <button class="methodological-popup-close js-popup-close">
                <img src="/local/templates/academy/img/icons/icon-close-popup-dark.svg" alt="alt" class="methodological-popup-close__icon">
            </button>
            <div class="methodological-popup__row">
                <div class="methodological-popup__left">
                    <div class="methodological-popup__title">{{ detailItem.title }}</div>
                    <div class="methodological-popup__block">
                        <div class="methodological-popup__subtitle">Рубрика</div>
                        <div class="methodological-popup__info">
                            <div class="methodological-popup__tags">
                                <div class="methodological-item__tag" :data-rubric-id="rubric.id" :class="getClassItem(rubric.label)" v-for="rubric in detailItem.rubrics" :key="rubric.id">{{ rubric.label }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="methodological-popup__block" v-if="(detailItem.education_subjects.length > 0)">
                        <div class="methodological-popup__subtitle">Предмет</div> 
                        <div class="methodological-popup__info"><span v-for="subject in detailItem.education_subjects">{{ subject.label }}</span> </div>
                    </div>
                    <div class="methodological-popup__block" v-if="detailItem.education_grade">
                    <div  v-if="detailItem.education_grade.value !== null">
                        <div class="methodological-popup__subtitle">Класс</div>
                        <div class="methodological-popup__info">{{ detailItem.education_grade.value }} класс</div>
                    </div></div>
                    <div class="methodological-popup__block">
                        <div class="methodological-popup__subtitle">Вид разработки</div>
                        <div class="methodological-popup__info">{{ detailItem.type.label }}</div>
                    </div>
                    <div class="methodological-popup__block" v-if="(detailItem.directions.length > 0)">                   
                        <div class="methodological-popup__subtitle">Направление деятельности</div>
                        <div class="methodological-popup__info"><span v-for="direction in detailItem.directions">{{ direction.label }}</span> </div>
                    </div>
                    <div class="methodological-popup__descr content content-little" v-if="detailItem.description">
                        <p>Краткое описание</p>                        
                        <p>{{ detailItem.description }}</p>
                    </div>
                </div>
                <div class="methodological-popup__right">
                    <div class="methodological-popup__sidebar">
                        <img :src="detailItem.owner_team.logo_url" :alt="detailItem.owner_team.name" class="methodological-popup__logo">
                        <div class="methodological-popup__block">
                            <div class="methodological-popup__subtitle">{{ detailItem.owner_team.description }}</div>
                        </div>
                        <div class="methodological-popup__block">
                            <div class="methodological-popup__subtitle">Дата публикации <br>{{ changeFormatDate(detailItem.published_at) }}</div>
                        </div>
                        <div class="methodological-popup__block" v-if="(detailItem.authors.length > 0)">
                            <div class="methodological-popup__subtitle">Сведения об авторах</div> 
                            <div class="methodological-popup__info" v-for="author in detailItem.authors">{{ author.name.last_name }} {{ author.name.first_name }} {{ author.name.middle_name }}{{ getAuthorInfo(author.academic_info) }}</div>
                        </div>
                        <div class="methodological-popup__block">
                        <div class="methodological-popup__subtitle">Источник</div>
                        <div class="methodological-popup__info">{{ detailItem.data.description }}</div>
                        </div>
                        <div class="methodological-popup__block">
                        <span class="paid-content" v-if="detailItem.data.paid">Ресурс может содержать платный контент</span>
                        <a :href="detailItem.data.url" class="methodological-popup-btn" target="_blank">
                            <img src="/local/templates/academy/img/icons/icon-link-white.svg" alt="alt" class="methodological-popup-btn__icon">
                            <span class="methodological-popup-btn__title">Ссылка на источник</span>
                        </a></div>
                        <a href="#popup-notice-error" class="btn btn-small btn-small-offset btn-solid-dark methodological-popup__notice js-popup-btn-target">Сообщить об ошибке</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="hidden">
        <div class="popup methodological-popup popup-notice" id="popup-notice-error">
            <button class="methodological-popup-close js-popup-close">
                <img src="/local/templates/academy/img/icons/icon-close-popup-dark.svg" alt="alt" class="methodological-popup-close__icon">
            </button>
            <form v-if="!isSend" class="popup-notice__form" name="error" @submit.prevent="sendForm(detailItem.id)">
                <label class="input popup-notice__field">
                    <span class="input__title">Введите комментарий</span>
                    <input type="text" class="input__field" v-model="errorComment" required>
                </label>
                <div
                    id="captcha-container"
                    class="smart-captcha"
                    data-sitekey="ysc1_MtDXrVM6yUspfP1ZKt7zYdhcaBxcLA37e2SFtwpNa17d2cb6"
                ></div>
                <div class="popup-notice__btns">
                    <button type="button" class="btn btn-middle btn-small-offset btn-solid-dark popup-notice__close js-popup-close">Отмена</button>
                    <button class="btn btn-middle btn-small-offset btn-fill-accent popup-notice__submit">Отправить</button>
                </div>
            </form>
            <div v-if="isSend" >
             <p>Сообщение успешно отправленно</p>
            </div>
        </div>
    </div>
`
}